import { z } from 'zod/v4';

import { QuantityRuntype } from '../backendTypes';
import { SourcingContextRuntype } from '../dataSource/dataSourceBackendTypes';

const AssemblyTypeTaggedRuntype = z.object({
    type: z.enum(['Box', 'Pcba', 'PcbOnly', 'Cable', 'System', 'BOM']),
    data: z.unknown().nullable().optional(),
});

const DemandGroupDemandAssemblyDTORuntype = z.object({
    id: z.string(),
    name: z.string(),
    assembly_type: AssemblyTypeTaggedRuntype,
});

const DemandPartIdDTORuntype = z.discriminatedUnion('type', [
    z.object({ type: z.literal('OffTheShelf'), data: z.string() }),
    z.object({ type: z.literal('Ipn'), data: z.string() }),
]);

const DemandGroupDemandKindDTORuntype = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('Assembly'), data: DemandGroupDemandAssemblyDTORuntype }),
    z.object({ kind: z.literal('Part'), data: z.object({ id: DemandPartIdDTORuntype }) }),
]);

export const DemandGroupDemandDTORuntype = z.object({
    id: z.string(),
    context: z.string().nullable(),
    quantity: QuantityRuntype,
    kind: DemandGroupDemandKindDTORuntype,
    production_start_date: z.string().nullable(),
    delivery_start_date: z.string().nullable(),
    delivery_end_date: z.string().nullable(),
    end_customer: z.string().nullable(),
    ship_to_site: z.string().nullable(),
    created_at: z.string(),
});

export type DemandGroupDemandDTO = z.infer<typeof DemandGroupDemandDTORuntype>;

export const DemandGroupDTORuntype = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
    demands: z.array(DemandGroupDemandDTORuntype),
    sourcing_scenario_ids: z.array(z.string()),
});

export type DemandGroupDTO = z.infer<typeof DemandGroupDTORuntype>;

export const BulkGetDemandGroupsRequestRuntype = z.discriminatedUnion('type', [
    z.object({ type: z.literal('DemandGroupIds'), data: z.array(z.string()) }),
    z.object({ type: z.literal('ProjectId'), data: SourcingContextRuntype }),
]);

export type BulkGetDemandGroupsRequest = z.infer<typeof BulkGetDemandGroupsRequestRuntype>;
